import { FiscalYear } from 'models';

export default function isDateIntersectsWithFiscalYear(
  date: Date,
  fiscalYear: FiscalYear
) {
  if (!fiscalYear.StartDate || !fiscalYear.EndDate) return false;

  let dateTime = date.getTime();
  let startDateTime = new Date(fiscalYear.StartDate).getTime();
  let endDateTime = new Date(fiscalYear.EndDate).getTime();

  return dateTime >= startDateTime && dateTime <= endDateTime;
}
